export const regExName = 
  // eslint-disable-next-line no-useless-escape
  /^[a-zA-Zà-úÀ-Úà-úÀ-Úâ-úÀ-Úā-ūĀ-ŪàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ0-9](?!.*[_|.\s]{2})(?!.*[.\s]{2})[a-zA-Zà-úÀ-Úà-úÀ-Úâ-úÀ-Úā-ūĀ-ŪàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ0-9.'`'_ \-]*$/i;

export const regExNameAndFemale = /^\S+ \S+$/i;
